/*
Totally taken from https://css-tricks.com/converting-color-spaces-in-javascript/
 */
export function hexToHSLA(
  hexa: string,
  options?: { saturation?: number; luminance?: number; alpha?: number },
) {
  let red = 0,
    green = 0,
    blue = 0;

  if (hexa.length == 4) {
    red = ("0x" + hexa[1] + hexa[1]) as unknown as number;
    green = ("0x" + hexa[2] + hexa[2]) as unknown as number;
    blue = ("0x" + hexa[3] + hexa[3]) as unknown as number;
  } else if (hexa.length == 7) {
    red = ("0x" + hexa[1] + hexa[2]) as unknown as number;
    green = ("0x" + hexa[3] + hexa[4]) as unknown as number;
    blue = ("0x" + hexa[5] + hexa[6]) as unknown as number;
  }

  // Then to HSL
  red /= 255;
  green /= 255;
  blue /= 255;

  const cmin = Math.min(red, green, blue);
  const cmax = Math.max(red, green, blue);
  const delta = cmax - cmin;

  let hue = 0,
    saturation = 0,
    luminance = 0;

  if (delta == 0) hue = 0;
  else if (cmax == red) hue = ((green - blue) / delta) % 6;
  else if (cmax == green) hue = (blue - red) / delta + 2;
  else hue = (red - green) / delta + 4;

  hue = Math.round(hue * 60);

  if (hue < 0) hue += 360;

  luminance = (cmax + cmin) / 2;
  saturation = delta == 0 ? 0 : delta / (1 - Math.abs(2 * luminance - 1));
  saturation = +(saturation * 100).toFixed(1);
  luminance = +(luminance * 100).toFixed(1);

  return `hsla(${hue},${options?.saturation ?? saturation}%,${options?.luminance ?? luminance}%, ${(options?.alpha ?? 100) / 100})`;
}
